<agr-page [pageTitle]="pageTitle()">
  <ng-container>
    <mat-tab-group>
      <!--Create App Wizard -->
      <mat-tab label="Create App Wizard">
        <br />
        <app-wizard-create></app-wizard-create>
      </mat-tab>
      <!--Delete App Wizard -->
      <mat-tab label="Delete App Wizard">
        <br />
        <app-wizard-delete></app-wizard-delete>
      </mat-tab>
      <!--Create App-Group Wizard -->
      <mat-tab label="Create App Group Wizard">
        <br />
        <app-wizard-create-group></app-wizard-create-group>
      </mat-tab>
      <!--Delete App-Group Wizard -->
      <mat-tab label="Delete App Group Wizard">
        <br />
        <app-wizard-delete-group></app-wizard-delete-group>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</agr-page>
